import React from 'react';
import './content.css';

const Content = () => {
    return (
        <div>
            <div className='content'>
                <div className='wraper'>
                <h1>
                    About Us
                </h1>
                </div>
                <div className='first'>
                <h2>
                    Entrepreneurship Cell at JEC Jabalpurr believes that entrepreneurship is not just about starting companies, but a pathway towards India�s socio-economic development. Our vision is to make students and faculty �entrepreneurial� in every work that they do. We hope to enable them to solve global challenges as we see students as the greatest capital and intend to nurture them, provide them with opportunities for excellence.
                </h2>
                </div>
                <div className='wraper'>
                <h1>
                     Vision
                </h1>
                </div>
                <div className='first'>
                    <h2>
                       E-Cell aims to unlock students� latent inventive potential. Not only do we show you the doors of opportunity but we also equip you to walk through it. Through our conference, social events, lectures, speaker engagements and workshops, we're hoping to bring together everyone interested in the startup world and to help students best utilize resources to found or join startups..
                    </h2>
                </div>
            </div>
        </div>
    );
}

export default Content;
